import { InvoiceRunsState } from './types';

export const state = (): InvoiceRunsState => initialState();

export const initialState = (): InvoiceRunsState => ({
  invoiceRuns: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['runDateTime'],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['runByEmployeeFullName'],
    },
  },
});
